"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SimpleTreeView_1 = require("@mui/x-tree-view/SimpleTreeView");
var TreeItem_1 = require("@mui/x-tree-view/TreeItem");
var fa_1 = require("react-icons/fa");
var CustomInput_1 = __importStar(require("./CustomInput"));
var CustomTreeView = function (_a) {
    var label = _a.label, value = _a.value, treeData = _a.treeData, _b = _a.placeholder, placeholder = _b === void 0 ? 'Ağaç Yapısını Filtrele...' : _b, onChange = _a.onChange;
    var _c = (0, react_1.useState)(''), filterTerm = _c[0], setFilterTerm = _c[1];
    // value prop'u ile başlayacak şekilde state'i ayarla
    var _d = (0, react_1.useState)(value), selectedItem = _d[0], setSelectedItem = _d[1];
    var _e = (0, react_1.useState)([]), expandedItems = _e[0], setExpandedItems = _e[1];
    var _f = (0, react_1.useState)(''), inputValue = _f[0], setInputValue = _f[1];
    var _g = (0, react_1.useState)(false), isInputDisabled = _g[0], setIsInputDisabled = _g[1];
    // value prop'u mount veya değiştiğinde, ilgili state'leri güncelle
    (0, react_1.useEffect)(function () {
        if (value) {
            var labelText = findLabelByValue(treeData, value);
            setInputValue(labelText);
            setIsInputDisabled(true);
            setSelectedItem(value);
        }
        else {
            handleReset();
        }
    }, [value, treeData]);
    var filterTree = function (nodes, term) {
        var normalizedTerm = term.toLocaleLowerCase('tr-TR');
        var pathsToExpand = [];
        var filteredNodes = nodes
            .map(function (node) {
            var normalizedLabel = node.label.toLocaleLowerCase('tr-TR');
            var matches = normalizedLabel.includes(normalizedTerm);
            var childrenResult = node.children && node.children.length > 0
                ? filterTree(node.children, term)
                : { filteredNodes: [], pathsToExpand: [] };
            if (matches || childrenResult.filteredNodes.length > 0) {
                pathsToExpand = __spreadArray(__spreadArray(__spreadArray([], pathsToExpand, true), [node.value], false), childrenResult.pathsToExpand, true);
                return __assign(__assign({}, node), { children: childrenResult.filteredNodes.length > 0 ? childrenResult.filteredNodes : undefined });
            }
            return null;
        })
            .filter(Boolean);
        return { filteredNodes: filteredNodes, pathsToExpand: pathsToExpand };
    };
    var _h = filterTerm
        ? filterTree(treeData, filterTerm)
        : { filteredNodes: treeData, pathsToExpand: [] }, filteredNodes = _h.filteredNodes, pathsToExpand = _h.pathsToExpand;
    (0, react_1.useEffect)(function () {
        if (filterTerm) {
            setExpandedItems(pathsToExpand);
        }
    }, [filterTerm, pathsToExpand]);
    var renderTree = function (nodes) {
        return nodes.map(function (node) { return (react_1.default.createElement(TreeItem_1.TreeItem, { key: node.value, itemId: node.value, label: react_1.default.createElement("span", { onClick: function () { return handleLabelClick(node.value); }, style: { cursor: 'pointer' } }, node.label.trim() === "" ? "Kök" : node.label) }, node.children ? renderTree(node.children) : null)); });
    };
    var handleSelectionChange = function (event, selectedId) {
        setSelectedItem(selectedId);
        onChange(selectedId);
        var selectedNode = findNodeByValue(treeData, selectedId);
        if (selectedNode) {
            setInputValue(selectedNode.label);
            setIsInputDisabled(true);
        }
    };
    var handleLabelClick = function (nodeValue) {
        setSelectedItem(nodeValue);
        onChange(nodeValue);
        var selectedNode = findNodeByValue(treeData, nodeValue);
        if (selectedNode) {
            setInputValue(selectedNode.label);
            setIsInputDisabled(true);
        }
    };
    var findNodeByValue = function (nodes, val) {
        for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
            var node = nodes_1[_i];
            if (node.value === val)
                return node;
            if (node.children) {
                var result = findNodeByValue(node.children, val);
                if (result)
                    return result;
            }
        }
        return null;
    };
    var findLabelByValue = function (nodes, val) {
        var node = findNodeByValue(nodes, val);
        return node ? node.label : '';
    };
    var handleExpandedItemsChange = function (event, itemIds) {
        setExpandedItems(itemIds);
    };
    var handleReset = function () {
        setFilterTerm('');
        setSelectedItem(null);
        setExpandedItems([]);
        setInputValue('');
        setIsInputDisabled(false);
        onChange(null);
    };
    return (react_1.default.createElement("div", null,
        label && react_1.default.createElement("label", null, label),
        react_1.default.createElement(CustomInput_1.default, { id: "tree-search", value: inputValue || filterTerm, inputType: CustomInput_1.InputType.TEXT, disabled: isInputDisabled, placeholder: placeholder, buttonIcon: react_1.default.createElement(fa_1.FaTimes, null), buttonClass: "btn btn-danger bg-soft-danger", buttonOnClick: handleReset, onChange: function (e) { return setFilterTerm(e.target.value); } }),
        react_1.default.createElement(SimpleTreeView_1.SimpleTreeView, { checkboxSelection: true, 
            // SimpleTreeView beklediği tip string olduğundan, dizi yerine selectedItem'ı direkt veriyoruz.
            selectedItems: selectedItem || '', expandedItems: expandedItems, onSelectedItemsChange: handleSelectionChange, onExpandedItemsChange: handleExpandedItemsChange }, renderTree(filteredNodes))));
};
exports.default = CustomTreeView;
